<template>
  <div class="switch-wrap" v-if="isShow">
    <div class="switch">
      <h3 class="switch-head pa-5">切換編輯不同語系/國家資料</h3>
      <div class="switch-body pa-5">
        <ul class="switch-infos mb-5 h4 ">
          <li>
            <span>如需針對單一語系進行編輯，請選擇語系後按下確認；</span>
            <span class="danger-01-emphasis--text">請注意</span>
            <span
              >一個語系可能會對應多個國家，
              當你選擇透過語系編輯/儲存資料時，將會<span
                class="danger-01-emphasis--text"
                >覆蓋掉</span
              >
            </span>
            <span>所有對應國家之內容。</span>
          </li>
          <li>
            如需針對單一國家內容進行客制編輯，請選擇國家後按下確認，前往編輯該國內容。
          </li>
        </ul>
        <div class="switch-language">
          <h4 class="switch-language__head mb-5">選擇語系 (關聯國家數)</h4>
          <div class="switch-language__body switch-row">
            <div class="switch-col" v-for="item in languages" :key="item.display_name">
              <button
                class="btn w-150px"
                :class="{
                  'btn-primary': tmpLang.id === item.id,
                  'btn-outlined': tmpLang.id != item.id,
                }"
                :disabled="item.id == 3 ? disabled : '' "
                @click="selectLang(item)"
              >
                <v-icon v-if="tmpLang.id === item.id">
                  check_circle
                </v-icon>
                <span>{{
                  `${item.display_name} (${item.countries_count})`
                }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="switch-nation">
          <h4 class="switch-nation__head mb-5">選擇國家</h4>
          <div class="switch-nation__search mb-5">
            <div class="form-input-group">
              <div class="prepend-icon"><v-icon>search</v-icon></div>
              <input type="text" class="pl-42px" v-model="filterCountry" />
            </div>
          </div>
          <div class="switch-nation__body switch-row">
            <div
              class="switch-col"
              v-for="item in filterCountries"
              :key="item.name"
            >
              <button
                class="btn w-150px"
                :class="{
                  'btn-primary': tmpCountry.code === item.code,
                  'btn-outlined': tmpCountry.code != item.code,
                }"
                :disabled="onlyshowChina.includes( item.code )? disabled : '' "
                @click="selectCountry(item)"
              >
                <v-icon v-if="tmpCountry.code === item.code">
                  check_circle
                </v-icon>
                <span>{{ `${item.display_name} (${item.code})` }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="switch-foot d-flex pa-5">
        <v-spacer></v-spacer>
        <button class="btn mr-10px" @click="cancelHandler">取消</button>
        <button class="btn btn-primary" @click="confirmHandler">確認</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'SwitchLanguageCountry',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectOption: {
      select: '繁中',
    },
    filterCountry: '',
    tmpCountry: null,
    tmpLang: {},
    onlyshowChina: ['cn', 'en'],
    onlyshowlanguage: [3],
  }),
  computed: {
    ...mapGetters(['local', 'lang']),
    ...mapState('language', ['languages', 'countries']),
    filterCountries() {
      return this.countries.filter((country) =>
        country.name.includes(this.filterCountry),
      );
    },
  },

  created() {
    this.getLanguages();
    this.tmpCountry = this.local;
    this.tmpLang = this.lang || {};
  },
  methods: {
    ...mapActions(['setLocal', 'setLang']),
    ...mapActions('language', {
      getLanguages: 'find',
    }),
    cancelHandler() {
      this.$emit('cancel-event');
    },
    confirmHandler() {
      if (this.tmpCountry !== null) {
        this.setLocal(this.tmpCountry);
      }
      this.setLang(this.tmpLang);

      window.location.reload();
      // this.$emit('confirm-event');
    },
    selectCountry(item) {
      this.tmpCountry = item;
    },
    selectLang(item) {
      this.tmpLang = this.tmpLang.id !== item.id ? item : {};
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-wrap {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-top: 20px;
  padding-top: 20px;
  background-color: rgba(25, 29, 31, 0.8);
  z-index: 100;
}

// custom grid
.switch {
  &-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
  }
  &-col {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 20px;
  }
}

.switch {
  width: 720px;
  margin: 0 auto;
  color: $ink-01-emphasis;
  background-color: #fff;
  box-shadow: 0 3px 5px -1px rgba(4, 48, 71, 0.06),
    0 0 1px 0 rgba(4, 48, 71, 0.1);

  &-head {
    height: 68px;
    box-shadow: 0 3px 5px -1px rgba(4, 48, 71, 0.06),
      0 0 1px 0 rgba(4, 48, 71, 0.1);
  }

  &-body {
    height: 700px;
    overflow-y: scroll;
    border-bottom: 1px solid #d7dee7;
  }
  @media (max-width: 1740px) {
    &-body {
      height: 500px;
    }
  }
  @media (max-width: 1200px) {
    &-body {
      height: 300px;
    }
  }

  &-foot {
    height: 80px;
    box-shadow: 0 1px 0 0 #d7dee7;
  }
}

.btn {
  position: relative;
  i {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    margin-left: 12px;
    color: white;
    font-size: 17px !important;
  }
}
</style>
